<template>
	<section
		v-dragscroll.x
		class="bg-white border-slate-300 flex flex-col overflow-hidden border-b border-t px-4 py-4 lg:px-16"
	>
		<div class="w-full">
			<!-- Breadcrumb -->
			<nav class="text-slate-600 flex items-center gap-2 text-sm">
				<template v-for="(link, i) in links" :key="i">
					<NuxtLink
						v-if="link"
						:to="i != links.length - 1 ? link.to : ''"
						:class="[
							'flex-shrink-0 whitespace-nowrap',
							i != links.length - 1 ? 'hover:text-primary' : 'text-slate-900 font-medium'
						]"
					>
						{{ link.name }}
					</NuxtLink>
					<Icon
						v-if="link && i != links.length - 1"
						name="mdi:chevron-left"
						class="h-[18px] w-[18px] flex-shrink-0"
					/>
				</template>
				<div class="pointer-events-none flex-shrink-0 opacity-0">...</div>
			</nav>
		</div>
	</section>
</template>

<script setup lang="ts">
import { type RouteLocationRaw } from "vue-router"

defineProps<{
	links: ({
		name: string
		to: RouteLocationRaw
	} | null)[]
}>()
</script>
